module.exports = __webpack_public_path__ + "fonts/Poppins-Light.2a47a29c.ttf";